module.exports = __webpack_public_path__ + "img/loginlogo.34aa5e92.png";